import React, { Component } from 'react';
import { ToastContainer } from 'react-toastify';
import toast from '../helpers/toast';
import Httpconfig from '../helpers/HttpconfigAdmin';
import Constant from '../../constants';

export default class UploadMasterProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      isUploading: false,
      uploadProgress: 0
    };
  }

  handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
          selectedFile.type !== 'application/vnd.ms-excel') {
        toast.error('Please select a valid Excel file (.xlsx or .xls)');
        return;
      }
      this.setState({ file: selectedFile });
      toast.success(`File selected: ${selectedFile.name}`);
    }
  };

  handleUpload = async () => {
    if (!this.state.file) {
      toast.error('Please select an Excel file first');
      return;
    }

    try {
      this.setState({ isUploading: true, uploadProgress: 30 });

      // Create FormData to upload file
      const formData = new FormData();
      formData.append('file', this.state.file);

      this.setState({ uploadProgress: 60 });

      // Upload to backend using Httpconfig
      const response = await Httpconfig.httptokenpostfile(
        `${Constant.siteurl}api/admin/product-master/upload-excel`,
        formData
      );

      this.setState({ uploadProgress: 100 });

      if (response.data && !response.data.error) {
        const result = response.data.data;
        
        toast.success(`Successfully processed ${result.summary.total} products. Added: ${result.summary.added || result.summary.inserted}, Duplicates: ${result.summary.duplicates}, Errors: ${result.summary.errors}`);

        // Download result Excel with Medicine IDs
        if (result.resultFile) {
          this.downloadResultExcel(result.resultFile, result.summary);
        } else if (result.downloadUrl) {
          // Alternative: Direct download from URL
          const link = document.createElement('a');
          link.href = result.downloadUrl;
          link.download = result.filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          toast.success('Result Excel downloaded with Medicine IDs');
        }

        // Reset form
        this.setState({ file: null });
        document.getElementById('excelFileInput').value = '';
      } else {
        toast.error(response.data.message || 'Upload failed');
      }

    } catch (error) {
      console.error('Upload error:', error);
      toast.error('Error uploading Excel file');
    } finally {
      this.setState({ isUploading: false, uploadProgress: 0 });
    }
  };

  downloadResultExcel = (base64Data, summary) => {
    try {
      // Convert base64 to blob
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });

      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `master_products_with_ids_${new Date().toISOString().slice(0, 10)}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      toast.success('Result Excel downloaded with Medicine IDs');
    } catch (error) {
      console.error('Download error:', error);
      toast.error('Error downloading result file');
    }
  };

  render() {
    const { file, isUploading, uploadProgress } = this.state;

    return (
      <div className="container-fluid">
        <ToastContainer />
        <div className="row">
          <div className="col-sm-12">
            <div className="page-title-box">
              <div className="row align-items-center">
                <div className="col-md-8">
                  <h4 className="page-title m-0">Upload Master Products</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="card m-b-30">
              <div className="card-body">
                <h4 className="mt-0 header-title mb-4">Upload Unmapped Products Excel</h4>
                
                <div className="alert alert-info alert-dismissible fade show" role="alert">
                  <strong>Workflow:</strong> Upload retailer's unmapped products Excel → System adds to master database → Generates Medicine IDs → Download result Excel → Share with retailer
                </div>

                <form>
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Select Excel File <span className="text-danger">*</span></label>
                    <div className="col-sm-9">
                      <div className="custom-file">
                        <input
                          type="file"
                          id="excelFileInput"
                          className="custom-file-input"
                          accept=".xlsx,.xls"
                          onChange={this.handleFileChange}
                          disabled={isUploading}
                        />
                        <label className="custom-file-label" htmlFor="excelFileInput">
                          {file ? file.name : 'Choose Excel file...'}
                        </label>
                      </div>
                      <small className="form-text text-muted">
                        <strong>Required columns:</strong> Product Name, Manufacturer, Strength, Form, Packaging, MRP
                      </small>
                    </div>
                  </div>

                  {file && (
                    <div className="form-group row">
                      <div className="col-sm-9 offset-sm-3">
                        <div className="alert alert-success mb-0">
                          <i className="fa fa-check-circle"></i> <strong>File Ready:</strong> {file.name} 
                          <span className="float-right badge badge-success">{(file.size / 1024).toFixed(2)} KB</span>
                        </div>
                      </div>
                    </div>
                  )}

                  {isUploading && (
                    <div className="form-group row">
                      <div className="col-sm-9 offset-sm-3">
                        <div className="progress" style={{ height: '25px' }}>
                          <div
                            className="progress-bar progress-bar-striped progress-bar-animated bg-success"
                            role="progressbar"
                            style={{ width: `${uploadProgress}%` }}
                            aria-valuenow={uploadProgress}
                            aria-valuemin="0"
                            aria-valuemax="100"
                          >
                            {uploadProgress}% Processing...
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="form-group row mb-0">
                    <div className="col-sm-9 offset-sm-3">
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        onClick={this.handleUpload}
                        disabled={!file || isUploading}
                      >
                        <i className="fa fa-cloud-upload mr-1"></i>
                        {isUploading ? 'Processing Excel...' : 'Upload to Master Database'}
                      </button>
                      {file && !isUploading && (
                        <button
                          type="button"
                          className="btn btn-secondary waves-effect ml-2"
                          onClick={() => {
                            this.setState({ file: null });
                            document.getElementById('excelFileInput').value = '';
                          }}
                        >
                          <i className="fa fa-times mr-1"></i> Clear
                        </button>
                      )}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="card m-b-30">
              <div className="card-body">
                <h4 className="mt-0 header-title mb-3">Instructions</h4>
                <div className="table-responsive">
                  <table className="table table-bordered mb-0">
                    <thead className="thead-light">
                      <tr>
                        <th width="80">Step</th>
                        <th>Action</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="text-center"><span className="badge badge-primary">1</span></td>
                        <td><strong>Receive Excel</strong></td>
                        <td>Get unmapped products Excel from retailer (downloaded from upload stock page)</td>
                      </tr>
                      <tr>
                        <td className="text-center"><span className="badge badge-primary">2</span></td>
                        <td><strong>Upload Here</strong></td>
                        <td>Select and upload the Excel file using the form above</td>
                      </tr>
                      <tr>
                        <td className="text-center"><span className="badge badge-primary">3</span></td>
                        <td><strong>System Process</strong></td>
                        <td>System adds products to master database and generates unique Medicine IDs</td>
                      </tr>
                      <tr>
                        <td className="text-center"><span className="badge badge-primary">4</span></td>
                        <td><strong>Download Result</strong></td>
                        <td>Download the result Excel file with Medicine IDs populated</td>
                      </tr>
                      <tr>
                        <td className="text-center"><span className="badge badge-primary">5</span></td>
                        <td><strong>Share with Retailer</strong></td>
                        <td>Send the result Excel back to retailer to re-upload and add stock</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
